<template>
  <div class="baogao-jc-detail">
    <div class="baogao-detail-top">
      <img src="~@/assets/images/zhuyuan/zy-jc-bj.png" alt="">
    </div>
    <van-cell-group inset>
      <van-cell title="开方医生">
        <template #default>
          {{ info.empName }}
        </template>
      </van-cell>
      <van-cell title="开方科室">
        <template #default>
          {{ info.orgName }}
        </template>
      </van-cell>
      <van-cell title="检查日期">
        <template #default>
          {{ info.studyTime | formatDate }}
        </template>
      </van-cell>
      <van-cell title="报告单号">
        <template #default>
          {{ info.pacsStudyuniqueid }}
        </template>
      </van-cell>
    </van-cell-group>
    <div class="list-box">
      <div class="list-wrap">
        <div class="list-item">检查项目</div>
        <div class="list-item">检查结果</div>
        <div class="list-item">诊断意见</div>
      </div>
      <div class="list-wrap list-wrap2">
        <div class="list-item">{{ info.studyscripTion }}</div>
        <div class="list-item">{{ info.reportDescribe }}</div>
        <div class="list-item">{{ info.reportDiagnose }}</div>
      </div>
    </div>
    <div class="download-btn">
      <van-button type="info" block @click="downloadPdf">下载报告</van-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import baseInfo from '@/utils/config'
export default {
  name: 'BaoGaoDetail',
  filters: {
    formatDate(value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      id: '',
      blhNo: '',
      list: [],
      info: {},
      numPages: '',
      src: '',
      show: false
    }
  },
  created() {
    this.id = this.$route.query.id
    // this.getReportDetail()
    const baogaoJcDetail = localStorage.getItem('baogaoJcDetail')
    if (!baogaoJcDetail) return
    const info = JSON.parse(baogaoJcDetail)
    if (this.id !== info.pacsStudyuniqueid) return
    this.info = info
    if (info.sleepReportBASE64) {
      this.pdfBase64 = info.sleepReportBASE64.split('=')[1]
    }
  },
  mounted() {},
  methods: {
    /* getReportDetail() {
      this.$Apis.getInspectReport({ blhNo: this.blhNo }).then(res => {
        console.log(res)
        this.info = res.data.find(item => item.id === this.id)
      })
    } */
    downloadPdf() {
      if (!this.pdfBase64) {
        this.$toast('暂无数据！')
        return
      }
      const url = baseInfo.BASE_URL_PDF + this.pdfBase64
      try {
        const link = document.createElement('a')
        link.href = url
        link.download = `检查报告_${this.info.pacsStudyuniqueid || Date.now()}.pdf`
        link.target = '_blank'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toast.success('开始下载PDF文件')
      } catch (error) {
        console.error('直接下载失败:', error)
        this.$toast.fail('下载失败，请重试')

        // 最后的回退方案：在新窗口打开
        window.open(url)
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.baogao-jc-detail{
  min-height: calc(100vh - .2rem);
  padding-bottom: .2rem;
  .baogao-detail-top{
    padding: .1rem .15rem;
    min-height: 1.25rem;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .list-box{
    margin: .1rem .15rem 0;
    padding: .1rem;
    background: #fff;
  }
  .list-wrap{
    margin-top: .1rem;
    display: flex;
    border-top: 1px solid #E8EAED;
    border-bottom: 1px solid #E8EAED;
    .list-item{
      color: #2B8CFF;
      background: #F8F8F8;
      flex: 1;
      word-break: break-all;
      padding: .1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      border-left: 1px solid #E8EAED;
    }
    :last-child{
      border-right: 1px solid #E8EAED;
    }
  }
  .list-wrap2{
    margin: 0;
    border-top: none;
    .list-item{
      color: #555;
      background: #fff;
    }
  }
}
.pdf-box {
  padding: .3rem .1rem .1rem;
}
.download-btn {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 500px;
  margin: 0.2rem 0 0;
  text-align: center;
  padding: 0.15rem 1rem 0.35rem;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 0.1rem 0.1rem 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
</style>
